/*!
 * Graph
 */
import boot from './boot'

export default {
  boot
}
